import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-inline" }
const _hoisted_2 = { class: "d-inline versionMenu" }


import { useConfirm } from "primevue/useconfirm";
import { traduceTexto } from '@/core/services/base/GlobalFunctios';


export default /*@__PURE__*/_defineComponent({
  __name: 'CloseSesionView',
  props: {
 version: String
},
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const closeSession = useConfirm();

const emit = __emit;
const msg = 
{
    closesesion:traduceTexto('globals.closesesion'),
    closeSesionQuest:traduceTexto('globals.closeSesionQuest'),
    cancel:traduceTexto('globals.cancel'),
    aceptar:traduceTexto('globals.aceptar')
};
const ConfirmCloseSession = () => 
{
    closeSession.require({
        message: msg.closeSesionQuest,
        header: msg.closesesion,                
        rejectLabel: msg.cancel,
        acceptLabel: msg.aceptar,
        accept: () => {            
            emit('onClose',true);
        }
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "footermnuWebBurger",
    onClick: ConfirmCloseSession
  }, [
    _createElementVNode("h5", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("i", { class: "pi pi-power-off" }, null, -1)),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('globals.closesesion')), 1)
    ]),
    _createElementVNode("span", _hoisted_2, " (" + _toDisplayString(__props.version) + ") ", 1)
  ]))
}
}

})